/**
 * Catalyst Link, wired to Inertia's client-side router.
 * See: https://catalyst.tailwindui.com/docs#client-side-router-integration
 */

import * as Headless from '@headlessui/react'
import { Link as InertiaLink, type InertiaLinkProps } from '@inertiajs/react'
import React, { forwardRef } from 'react'

// Public prop type is plain-anchor based so it stays nameable for declaration
// emit (Inertia's InertiaLinkProps references a non-exported base type). We
// cast to InertiaLinkProps only at the call site.
export type LinkProps = { href: string } & Omit<React.ComponentPropsWithoutRef<'a'>, 'href'>

export const Link = forwardRef(function Link(
  props: LinkProps,
  ref: React.ForwardedRef<HTMLAnchorElement>
) {
  return (
    <Headless.DataInteractive>
      <InertiaLink {...(props as InertiaLinkProps)} ref={ref} />
    </Headless.DataInteractive>
  )
})
